import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { AuthService } from "../pages/auth/services/auth.service";

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    map((isAuthed) => {
      if (!isAuthed)
        return router.createUrlTree(["/auth/login"], {
          queryParams: route.queryParams,
        });
      return true;
    })
  );
};
